var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 102.44 97.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:red;stroke:red;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.58,
    y: 5,
    width: 87.11,
    height: 87.11
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_29_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    className: "cls-3",
    d: "M51.13,11.67c20.61,0,37.32,16.71,37.32,37.32s-16.71,37.32-37.32,37.32S13.81,69.6,13.81,48.99c.02-20.6,16.72-37.3,37.32-37.33m0-1.56C29.65,10.1,12.24,27.51,12.24,48.99s17.41,38.89,38.89,38.89,38.88-17.41,38.89-38.88c0-21.48-17.41-38.89-38.88-38.89h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    className: "cls-3",
    d: "M51.13,92.11c-.43,0-.78-.35-.78-.78V5.79c-.02-.43,.32-.79,.75-.81,.43-.02,.79,.32,.81,.75,0,.02,0,.04,0,.06V91.33c0,.43-.35,.78-.78,.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    className: "cls-3",
    d: "M93.9,49.34H8.36c-.43-.02-.77-.38-.75-.81,.01-.41,.34-.74,.75-.75H93.9c.43,.02,.77,.38,.75,.81-.01,.41-.34,.74-.75,.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    className: "cls-3",
    d: "M51.13,58.94c-5.5,0-9.95-4.45-9.95-9.95s4.45-9.95,9.95-9.95,9.95,4.45,9.95,9.95h0c0,5.49-4.46,9.94-9.95,9.95m0-19.12c-5.06,0-9.17,4.1-9.17,9.17s4.1,9.17,9.17,9.17,9.17-4.1,9.17-9.17c0-5.06-4.11-9.16-9.17-9.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    className: "cls-3",
    d: "M51.13,68.23c-10.63,0-19.24-8.62-19.24-19.24,0-10.63,8.62-19.24,19.24-19.24,10.63,0,19.24,8.62,19.24,19.24-.01,10.62-8.62,19.23-19.24,19.24m0-37.71c-10.2,0-18.46,8.27-18.46,18.46s8.27,18.46,18.46,18.46c10.2,0,18.46-8.27,18.46-18.46-.01-10.19-8.27-18.45-18.46-18.46"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.bae3320fa5a55b85e3627c2d2a5315b7.svg";
export { ForwardRef as ReactComponent };